import React from 'react';
import { useHistory, useParams } from 'react-router';
import { Loader } from '../../../../Common/Components/Loader';
import { Button, Divider, Paper, Typography } from '@mui/material';
import { sqlServerService } from '../SqlServerService';
import { Check, Clear } from '@mui/icons-material';
import { useFormStyles } from '../../../../Common/Styles';
import DeleteInfoCard from '../../../../Common/Components/DeleteInfoCard';
import { showToast } from '../../../../lib/toast';

interface UriParams {
  sqlserver: string;
}

const SqlServerDelete = () => {
  const { classes } = useFormStyles();
  const params = useParams<UriParams>();
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();

  const handleCancel = () => {
    history.push('/sqlserver');
  };

  const handleDelete = async () => {
    setLoading(true);
    await sqlServerService
      .deleteSqlServer(params.sqlserver)
      .then((deletedSqlServer) =>
        showToast({
          title: `deleted sql server ${deletedSqlServer.ServerName} successfully! along with respective failover groups`,
          type: 'success',
        }),
      )
      .catch((error) => {
        showToast({
          type: 'error',
          title: `failed to delete the server ${error}`,
        });
      })
      .finally(() => {
        setLoading(false);
        handleCancel();
      });
  };

  return (
    <div>
      <Loader loading={loading} />
      <Paper>
        <Typography variant="h5" className={classes.title}>
          Delete Sql Server
        </Typography>
        <DeleteInfoCard text={`this Sql Server : ${params.sqlserver}`} />
        <Divider className={classes.divider} />
        <Paper style={{ textAlign: 'right' }}>
          <Button
            variant="contained"
            onClick={handleDelete}
            className={classes.button}
            startIcon={<Check />}
          >
            Yes{' '}
          </Button>
          <Button
            variant="contained"
            onClick={handleCancel}
            className={classes.button}
            startIcon={<Clear />}
          >
            No{' '}
          </Button>
        </Paper>
      </Paper>
    </div>
  );
};

export default SqlServerDelete;
